<template>
  <div class="history-event">
    <Table
      :table-config="tabelConfig"
      :template-data="tabelData"
      :pagination="pagination"
    ></Table>
    <el-dialog title="报警日志" :visible.sync="logVisible" :before-close="closeLog">
      <div class="log" style="height: 500px; overflow-y: auto">
        <Steps :timeline-list="logData.handlers">
          <div
            v-for="(i, index) in logData.handlers"
            style="display: inline-block"
            :key="index"
            :slot="'header' + index"
          >
            <span class="handleUserName">{{ i.userName }}</span>
            <span class="alarmType">【{{ i.handleTypeName }}】</span>
            <span class="centerName">{{ i.areaName }}</span>
          </div>
          <div
            v-for="(i, index) in logData.handlers"
            style="display: inline-block"
            :key="index"
            :slot="'content' + index"
          >
            <div class="content">
              <div class="item-m">
                <span>时间:</span><span>{{ i.createGmt }}</span>
              </div>
              <div class="item-m">
                <span>地点:</span><span>{{ i.areaName }}</span>
              </div>
              <div class="item-m">
                <span>内容:</span><span>{{ i.content ? i.content : "暂无内容" }}</span>
              </div>
              <div class="item-m" v-if="i.clueFiles.length != 0">
                <span>图片:</span>
                <div class="img">
                  <div v-for="(item, index) in i.clueFiles" :key="index">
                    <el-image
                      v-if="item.fileType == 1"
                      style="width: 100px; height: 100px"
                      :src="item.fileUrl"
                      :preview-src-list="[item.fileUrl]"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="item-m" v-if="i.clueFiles.length != 0">
                <span>音频:</span>
                <div class="img" v-for="(item, index) in i.clueFiles" :key="index">
                  <m-audio v-if="item.fileType == 4" :src="item.fileUrl"></m-audio>
                </div>
              </div>
            </div>
          </div>
        </Steps>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapAPI } from "@/api-path/command-center.js";
import { listAPI } from "@/api-path/command-center.js";
export default {
  name: "history-event",
  data() {
    return {
      eventUserId: "",
      tabelConfig: {
        rows: [
          {
            label: "报警时间",
            prop: "createGmt",
          },
          {
            label: "报警中心",
            prop: "currentCenter",
          },
          {
            label: "报警来源",
            prop: "alarmSource",
          },
          {
            label: "报警方式",
            prop: "alarmType",
          },
        ],
        rowButtons: {
          items: [
            {
              icon: "el-icon-view",
              fn: (value) => {
                console.log(value);
                this.$http
                  .get(listAPI.datail + "?alarmId=" + value.alarmId)
                  .then((res) => {
                    if (res.status === 200) {
                      res.result.handlers.map((item) => {
                        item.isOpen = false;
                      });
                      this.logVisible = true;
                      this.logData = res.result;
                    }
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        small: true,
        total: 0,
        page: 1,
        size: 14,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      searchParams: {
        page: 1,
        size: 14,
        userId: "",
      },
      tabelData: [],
      logVisible: false,
      logData: [],
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    closeLog() {
      this.logVisible = false;
    },
    getListData() {
      this.searchParams.userId = localStorage.getItem("eventUserId");
      this.$http.get(mapAPI.eventHistory, { params: this.searchParams }).then((res) => {
        if (res.status === 200) {
          res.result.pageList.map((item) => {
            // item.alarmSource = this.matchFn.matchCodeName('ALARM_SOURCE', item.alarmSource)
            item.alarmType = this.matchFn.matchCodeName("ALARM_TYPE", item.alarmType);
          });
          this.tabelData = res.result.pageList;
          this.pagination.total = res.result.total;
        }
      });
    }, // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.getListData();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.getListData();
    },
  },
};
</script>

<style lang='less'>
	.history-event{
		height: 100%; 
		overflow-y: auto; 
		overflow-x: hidden;
		.components-tabel{
			height:100%;
		}
	}
</style>
